import { render, staticRenderFns } from "./CashupView.vue?vue&type=template&id=6c1d86e7"
import script from "./CashupView.vue?vue&type=script&lang=js"
export * from "./CashupView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports